module.exports = __webpack_public_path__ + "static/media/jj.28b61423.png";